import { type FC } from 'react';

import BackButton, { type BackButtonProps } from 'components/BackButton';

const LoginBackButton: FC<BackButtonProps> = (props) => (
  <BackButton marginBottom="space-40" size="md" {...props} />
);

export default LoginBackButton;
